import CityField from 'components/CityField';
import ButtonV2 from 'components/common/ButtonV2';
import CountryField from 'components/CountryField';
import FormikInputField from 'components/Fields/FormikInputField';
import StateField from 'components/StateField';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';

const AddressForm = ({ values, show, onSaveAddress, setShowAddressForm }) => {
  const [saveButtonLoading, setSaveButtonLoading] = React.useState(false);
  const { setFieldValue } = useFormikContext();

  const isAddressInfoValid = (addressInfo) => {
    if (!addressInfo) return false; // Handle undefined/null

    const requiredFields = ['street', 'city', 'state', 'country']; // Fields to check
    return requiredFields.every((field) => {
      const value = addressInfo[field];
      // Check if value exists (not empty string, null, or undefined)
      return value !== '' && value !== null && value !== undefined;
    });
  };

  const onClickSave = async () => {
    const isValid = isAddressInfoValid(values?.addressInfo);
    if (!isValid) {
      toast.error('Please fill all the required fields in address info.');
      return;
    }
    setSaveButtonLoading(true);

    try {
      await onSaveAddress(show);
    } catch (error) {
      console.error('Error saving address:', error);
    } finally {
      setSaveButtonLoading(false);
      setShowAddressForm(0);
      setFieldValue('addressInfo', {
        street: '',
        area: '',
        city: null,
        state: null,
        country: null,
        pinCode: '',
      });
    }
  };

  return (
    <Card style={{ border: 'none' }}>
      <CardTitle
        style={{
          padding: '10px',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>Add New Address</div>
        <div style={{ textAlign: 'right' }}>
          <ButtonV2
            color="secondary"
            type="button"
            outline
            className="py-1 rounded-0 f-14 ms-2 border-radius-4"
            onClick={() => {
              setFieldValue('addressInfo', {
                street: '',
                area: '',
                city: null,
                state: null,
                country: null,
                pinCode: '',
              });
              setShowAddressForm(0);
            }}
          >
            Discard
          </ButtonV2>
          <ButtonV2
            color="primary"
            key="update-charges"
            size="sm"
            style={{
              marginLeft: '10px',
            }}
            className="border-radius-4"
            onClick={onClickSave}
            disabled={saveButtonLoading}
          >
            {saveButtonLoading ? 'Saving...' : 'Save'}
          </ButtonV2>
        </div>
      </CardTitle>
      <CardBody style={{ padding: '10px' }}>
        <Row>
          <Col sm={6}>
            <Field
              id="addressInfo.street"
              name="addressInfo.street"
              type="text"
              label="Street Address"
              component={FormikInputField}
              placeholder="Enter Street Address"
              required
            />
          </Col>
          <Col sm={6}>
            <Field
              id="addressInfo.area"
              name="addressInfo.area"
              type="text"
              label="Landmark"
              component={FormikInputField}
              placeholder="Enter Landmark"
            />
          </Col>
          <Col sm={6}>
            <Field
              id="addressInfo.pinCode"
              name="addressInfo.pinCode"
              type="text"
              label="Zip Code"
              component={FormikInputField}
              placeholder="Enter Zip Code"
            />
          </Col>
          <Col sm={6}>
            <CountryField
              id="country"
              label="Country"
              name="addressInfo.country"
              required
              placeholder="Select Country"
            />
          </Col>
          <Col sm={6}>
            <StateField
              id="state"
              label="State"
              name="addressInfo.state"
              // setFieldValue={setFieldValue}
              countryId={values?.addressInfo?.country?.id}
              required
              placeholder="Select State"
            />
          </Col>
          <Col sm={6}>
            <CityField
              id="city"
              label="City"
              name="addressInfo.city"
              countryId={values?.addressInfo?.country?.id}
              stateId={values?.addressInfo?.state?.id}
              placeholder="Select City"
              required
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default AddressForm;
